import {getConfig} from '@salesforce/pwa-kit-runtime/utils/ssr-config'
import {invariant} from './invariant'
import type {Request} from 'express'
import {toClientPreferences} from '../context/site-preferences'
import {toServerPreferences} from '../context/server-site-preferences'
import type {ServerSitePrefs} from '../context/server-site-preferences'
import {isServer} from '@salesforce/retail-react-app/app/utils/utils'
import {fetchPreferences, PreferencesResponse} from './fetchPreferences'

export type SitePreferencesResponse = PreferencesResponse

export const fetchCustomSitePreferences = async (
    req: Request
): Promise<SitePreferencesResponse> => {
    const config = getConfig()
    const {app} = config as {app: {commerceAPI: {parameters: {siteId: string}}}}
    const siteId = app.commerceAPI.parameters.siteId
    return fetchPreferences(req, 'site-custom-preferences', `?siteId=${siteId}`, 'site')
}

export const getClientSitePreferences = async (req: Request) => {
    invariant(isServer, 'toClientPreferences should only be called on the server')

    const data = await fetchCustomSitePreferences(req)

    invariant(Array.isArray(data), 'Expected data to be an array')
    return toClientPreferences(data)
}

export const getServerSitePreferences = async (req: Request): Promise<ServerSitePrefs> => {
    invariant(isServer, 'getServerSitePreferences should only be called on the server')

    const data = await fetchCustomSitePreferences(req)

    invariant(Array.isArray(data), 'Expected data to be an array')
    return toServerPreferences(data)
}
